import React, { CSSProperties } from 'react';
import styles from './BodyText.module.scss';
import { withStyles } from '../../../utils/utils';

const cn = withStyles(styles);

export type BodyTextProps = {
  size?: 'rg' | 'sm';
  weight?: 'rg' | 'md' | 'em';

  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
};

const BodyText: React.FC<BodyTextProps> = ({ size = 'rg', weight = 'rg', children, className, ...props }) => {
  return (
    <div className={cn('bodyTextContainer', `size-${size}`, `emphasis-${weight}`, className)} {...props}>
      {children}
    </div>
  );
};

export default BodyText;
